import { Draft } from '@reduxjs/toolkit';
import { IDesignerTemplateState } from './IDesignerTemplateState';

export function applyClearProjectToTemplateReducer(state: Draft<IDesignerTemplateState>) {
  state.isTemplateModalOpen = false;
}
